import React from 'react';
import styled from 'styled-components';
import HvSvg from 'src/components/HvSvg';
import {
  NotificationComponentContainer,
  CheckmarkIconContainer,
} from './styled';

const SaveNotificationContainer = styled.div`
  ${NotificationComponentContainer}
`;

const SaveNotification = () => (
  <SaveNotificationContainer data-selenium="saveNotificationText">
    <CheckmarkIconContainer size={14}>
      <HvSvg src={require('src/assets/icons/checkmark.svg')} disabled={false} />
    </CheckmarkIconContainer>
    New style saved
  </SaveNotificationContainer>
);

export default SaveNotification;
